export default __webpack_public_path__ + "static/media/user-added-icon.3b504b7f.svg";